<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    var that = this
    window.onload = function() {
      if (!window.sessionStorage['tempFlag']) {
        console.log('关闭~~')
        localStorage.clear()
        that.$router.push({ name: 'login' })
      } else {
        console.log('刷新~~~')
        window.sessionStorage.removeItem('tempFlag')
      }
    }

    window.onunload = function () {
      window.sessionStorage['tempFlag'] = false
    }

    window.onbeforeunload = function () {
      window.sessionStorage['tempFlag'] = true
    }
  }
}
</script>

<style lang="scss">
// 引入自定义全局scss
@import "./style/common.scss";
#app {
  width: 100vw;
  height: 100vh;
  overflow: hiddden;
  background: #f2f3f5;
}
</style>
